<template>
  <div class="app-container">
    <list ref="list" />
  </div>
</template>
<script>
import curdMixins from "@/mixins/curd";
import list from "@/components/cashier/limitsummer/list";

export default {
  name: "limitsummer",
  mixins: [curdMixins],
  components: {
    list,
  },
  mounted() {},
  methods: {},
};
</script>